import { memo } from 'react';
import { KeyboardLayouts } from '../../SimpleKeyboard/Layout';
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { KioskFormEmailField } from './KioskFormEmailField/KioskFormEmailFIeld';
import { WebFormEmailField } from './WebFormEmailField/WebFormEmailField';
import { FormEmailFieldProps } from './FormEmailField.types';

const FormEmailField = memo(({
    name,
    id,
    title,
    label,
    ariaLabel,
    disabled,
    required = false,
    autoFocus,
    initiallyMasked = false,
    keyboardLayout = KeyboardLayouts.Email,
    shiftAfterSpace = false,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
    tabFocusRefContext,
    onChangeCallback,
    noValidation = false,
}: FormEmailFieldProps) => {

    return (
        isElectron() ? (
            <KioskFormEmailField
                name={name}
                id={id}
                title={title}
                label={label}
                ariaLabel={ariaLabel}
                disabled={disabled}
                required={required}
                autoFocus={autoFocus}
                initiallyMasked={initiallyMasked}
                keyboardLayout={keyboardLayout}
                shiftAfterSpace={shiftAfterSpace}
                shiftAfterPeriod={shiftAfterPeriod}
                shiftAfterAmpersand={shiftAfterAmpersand}
                hideKeyboardOnClickOut={hideKeyboardOnClickOut}
                capsLock={capsLock}
                fullWidth={fullWidth}
                seventyFivePercentWidth={seventyFivePercentWidth}
                tabFocusRefContext={tabFocusRefContext}
                onChangeCallback={onChangeCallback}
                noValidation={noValidation}
            />
        ) : (
            <WebFormEmailField
                name={name}
                id={id}
                title={title}
                label={label}
                ariaLabel={ariaLabel}
                disabled={disabled}
                required={required}
                autoFocus={autoFocus}
                initiallyMasked={initiallyMasked}
                capsLock={capsLock}
                fullWidth={fullWidth}
                seventyFivePercentWidth={seventyFivePercentWidth}
                tabFocusRefContext={tabFocusRefContext}
                onChangeCallback={onChangeCallback}
                noValidation={noValidation}
            />
        )
    );
});

export default FormEmailField;
